import React from "react";

const LOGO_URL = "https://customer-assets-agu9un31.emergentagent.net/job_wealth-journey-os/artifacts/p71txwc9_Reliserve%20Wealth%20Logo.png";

/**
 * Reliserve Wealth wordmark + logomark.
 * Full-logo variant used on marketing / public pages.
 * `mono` variant hides the wordmark and shows just the logomark on a coloured tile
 * — used in the app sidebar and compact headers.
 */
export default function BrandLogo({ size = "md", mono = false, className = "" }) {
  const heights = { sm: 48, md: 64, lg: 88, xl: 128 };
  const h = heights[size] || 32;
  if (mono) {
    // Compact monogram tile: a rounded square filled with the brand teal that
    // hosts the logomark. Used in sidebar / mobile headers.
    return (
      <div
        className={`flex items-center justify-center rounded-lg bg-primary text-white shadow-sm ${className}`}
        style={{ height: h, width: h }}
        aria-label="Reliserve Wealth"
      >
        <img
          src={LOGO_URL}
          alt=""
          className="object-contain"
          style={{ height: h - 6, width: h - 6, filter: "brightness(0) invert(1)" }}
        />
      </div>
    );
  }
  return (
    <img
      src={LOGO_URL}
      alt="Reliserve Wealth"
      className={"select-none " + className}
      style={{ height: h, width: "auto" }}
      draggable={false}
    />
  );
}

export { LOGO_URL };
